export const PARENT_PRODUCT_TOOLTIP =
    "Describe both the part's parent product and the part's end-use, e.g. engine part for the testing and development of a spark-ignition internal combustion piston engine used in a sport utility vehicle (SUV)."
export const DONOT_SHOW_UPDATED_TERM_MODAL = 'DONOT_SHOW_UPDATED_TERM_MODAL'
export const UPDATED_TERM_START_DATE = '2022-01-01'
export const NOT_AVAILABLE = 'Not available'
